/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum RecorderViewMode {
    Default = 0,
    DualScreen = 1,
    ProTrainingOnly = 2,
    OsceTrainingOnly = 3,
    Server = 4,
}
